import Vue from "vue";
import Vuex from "vuex";
import tab from "./tab";
import enterHome from "./enterHome";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: sessionStorage.getItem("user_token") || "",
  },
  mutations: {
    setUser(state, data) {
      state.user = data;
      sessionStorage.setItem("user_token", state.user);
    },
  },
  actions: {},
  modules: {
    tab,
    // message
    enterHome,
  },
});
